var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 6",
    d: "M3.5 7L0 0h7z",
    fill: "#6f9d20"
  })));
}

export default __webpack_public_path__ + "62c84f5566feadc0a39e0d716a7856ac.svg";
export { SvgIconPoint as ReactComponent };